/* =====================================================================
   WHAT THE GIFT — CRO build v2
   Vanilla JS. No framework. Shopify-portable.
   Handles: announce rotation, cart state, pincode check, sticky ATC,
   personalization UI, free-shipping progress, toast, WhatsApp capture.
   ===================================================================== */

(function() {
  'use strict';

  // ---------- STATE (localStorage-backed cart) ----------
  const Cart = {
    key: 'wtg2_cart',

    read() {
      try {
        return JSON.parse(
          localStorage.getItem(this.key) || '[]'
        );
      } catch {
        return [];
      }
    },

    write(items) {
      localStorage.setItem(
        this.key,
        JSON.stringify(items)
      );

      this.syncBadges(items);
    },

    count() {
      return this.read().reduce(
        (s, i) => s + i.qty,
        0
      );
    },

    subtotal() {
      return this.read().reduce(
        (s, i) => s + i.price * i.qty,
        0
      );
    },

    add(item) {
      const items = this.read();

      const ex = items.find(
        i =>
          i.id === item.id &&
          i.variant === item.variant
      );

      if (ex) {
        ex.qty += item.qty || 1;
      } else {
        items.push(
          Object.assign(
            { qty: 1 },
            item
          )
        );
      }

      this.write(items);
    },

    remove(id, variant) {
      this.write(
        this.read().filter(
          i =>
            !(
              i.id === id &&
              i.variant === variant
            )
        )
      );
    },

    setQty(id, variant, qty) {
      const items = this.read();

      const ex = items.find(
        i =>
          i.id === id &&
          i.variant === variant
      );

      if (!ex) return;

      if (qty <= 0) {
        return this.remove(
          id,
          variant
        );
      }

      ex.qty = qty;

      this.write(items);
    },

    syncBadges(items) {

      const count = (
        items || this.read()
      ).reduce(
        (s, i) => s + i.qty,
        0
      );

      document
        .querySelectorAll('[data-cart-count]')
        .forEach(el => {

          el.textContent = count;

          el.style.display =
            count > 0 ? '' : 'none';

        });
    }
  };

  window.Cart = Cart;


  // ---------- TOAST ----------
  let toastEl = null;

  window.toast = function(msg, ms) {

    if (!toastEl) {

      toastEl =
        document.createElement('div');

      toastEl.className = 'toast';

      document.body.appendChild(
        toastEl
      );

    }

    toastEl.textContent = msg;

    toastEl.classList.add('show');

    clearTimeout(toastEl._t);

    toastEl._t = setTimeout(
      () =>
        toastEl.classList.remove(
          'show'
        ),
      ms || 2000
    );

  };


  // ---------- ANNOUNCE BAR ----------
  function initAnnounce() {

    const track =
      document.querySelector(
        '[data-announce-track]'
      );

    if (!track) return;

    const msgs =
      track.querySelectorAll(
        '.announce-msg'
      );

    if (msgs.length < 2) return;

    let idx = 0;

    msgs[0].classList.add(
      'active'
    );

    setInterval(() => {

      msgs[idx].classList.remove(
        'active'
      );

      idx =
        (idx + 1) %
        msgs.length;

      msgs[idx].classList.add(
        'active'
      );

    }, 5000);


    const close =
      document.querySelector(
        '[data-announce-close]'
      );

    if (close) {

      close.addEventListener(
        'click',
        () => {

          const announce =
            document.querySelector(
              '.announce'
            );

          if (announce) {
            announce.style.display =
              'none';
          }

          localStorage.setItem(
            'wtg_announce_dismissed',
            Date.now()
          );

        }
      );

    }


    if (
      localStorage.getItem(
        'wtg_announce_dismissed'
      )
    ) {

      const dismissed =
        parseInt(
          localStorage.getItem(
            'wtg_announce_dismissed'
          ),
          10
        );

      if (
        Date.now() -
          dismissed <
        7 *
          24 *
          3600 *
          1000
      ) {

        const announce =
          document.querySelector(
            '.announce'
          );

        if (announce) {
          announce.style.display =
            'none';
        }

      }
    }
  }


  // ---------- PINCODE CHECK ----------
  const SERVICEABLE_PINCODES = {

    '110001': {
      city: 'New Delhi',
      sameDay: true,
      eta: 0
    },

    '110020': {
      city: 'New Delhi',
      sameDay: true,
      eta: 0
    },

    '400001': {
      city: 'Mumbai',
      sameDay: true,
      eta: 0
    },

    '400051': {
      city: 'Mumbai',
      sameDay: true,
      eta: 0
    },

    '560001': {
      city: 'Bengaluru',
      sameDay: true,
      eta: 0
    },

    '560034': {
      city: 'Bengaluru',
      sameDay: true,
      eta: 0
    },

    '600001': {
      city: 'Chennai',
      sameDay: false,
      eta: 1
    },

    '700001': {
      city: 'Kolkata',
      sameDay: false,
      eta: 1
    },

    '500001': {
      city: 'Hyderabad',
      sameDay: true,
      eta: 0
    },

    '411001': {
      city: 'Pune',
      sameDay: false,
      eta: 1
    }

  };


  function pincodeLookup(pin) {

    if (
      SERVICEABLE_PINCODES[pin]
    ) {
      return SERVICEABLE_PINCODES[
        pin
      ];
    }

    /*
      Any valid Indian 6-digit
      pincode falls back to
      standard 3-day ETA.
    */
    if (/^\d{6}$/.test(pin)) {

      return {
        city: 'Your area',
        sameDay: false,
        eta: 3
      };

    }

    return null;
  }


  function formatDeliveryDate(
    daysFromNow,
    sameDay
  ) {

    const d = new Date();

    const cutoffHour = 21;

    if (
      sameDay &&
      d.getHours() < cutoffHour
    ) {

      return {

        label:
          'Today, ' +
          d.toLocaleDateString(
            'en-IN',
            {
              day: 'numeric',
              month: 'short'
            }
          ),

        cutoff:
          cutoffMsg()

      };

    }

    d.setDate(
      d.getDate() +
        (daysFromNow || 1)
    );

    return {

      label:
        d.toLocaleDateString(
          'en-IN',
          {
            weekday: 'short',
            day: 'numeric',
            month: 'short'
          }
        ),

      cutoff: null

    };

  }


  function cutoffMsg() {

    const now = new Date();

    const cutoff =
      new Date();

    cutoff.setHours(
      21,
      0,
      0,
      0
    );

    if (now >= cutoff) {
      return null;
    }

    const diff =
      cutoff - now;

    const h =
      Math.floor(
        diff / 3600000
      );

    const m =
      Math.floor(
        (diff % 3600000) /
          60000
      );

    return (
      `Order within ${h}h ${m}m for same-day delivery`
    );

  }


  function initPincode() {

    const boxes =
      document.querySelectorAll(
        '[data-pincode-box]'
      );

    boxes.forEach(box => {

      const input =
        box.querySelector(
          'input'
        );

      const btn =
        box.querySelector(
          '[data-pincode-check]'
        );

      const status =
        box.querySelector(
          '[data-pincode-status]'
        );

      const cutoffEl =
        box.querySelector(
          '[data-pincode-cutoff]'
        );


      if (
        !input ||
        !btn ||
        !status
      ) {
        return;
      }


      /*
        These three values now
        come from Shopify Theme
        Customizer.
      */

      const successTemplate =
        box.dataset
          .successTemplate ||
        '✓ Delivered by {date} · {city}';

      const invalidText =
        box.dataset
          .invalidText ||
        '✕ Please enter a valid 6-digit pincode';

      const areaText =
        box.dataset
          .areaText ||
        'Your area';


      // Restore previously entered pincode
      const saved =
        localStorage.getItem(
          'wtg_pincode'
        );

      if (saved) {

        input.value = saved;

        runCheck(saved);

      }


      function runCheck(pin) {

        const r =
          pincodeLookup(pin);


        if (!r) {

          status.classList.add(
            'error'
          );

          status.textContent =
            invalidText;

          if (cutoffEl) {
            cutoffEl.textContent =
              '';
          }

          return;
        }


        localStorage.setItem(
          'wtg_pincode',
          pin
        );


        const headerPin =
          document.querySelector(
            '[data-header-pincode]'
          );

        if (headerPin) {
          headerPin.textContent =
            pin;
        }


        const dd =
          formatDeliveryDate(
            r.eta,
            r.sameDay
          );


        const city =
          r.city === 'Your area'
            ? areaText
            : r.city;


        status.classList.remove(
          'error'
        );


        /*
          Theme editor examples:

          ✓ Delivered by {date} · {city}

          Estimated delivery:
          {date} in {city}

          Get it by {date}
        */

        status.innerHTML =
          successTemplate

            .replace(
              /\{date\}/g,
              `<strong>${dd.label}</strong>`
            )

            .replace(
              /\{city\}/g,
              city
            );


        if (cutoffEl) {

          cutoffEl.textContent =
            dd.cutoff || '';

        }

      }


      btn.addEventListener(
        'click',
        () => {

          const pin =
            (
              input.value ||
              ''
            ).trim();

          runCheck(pin);

        }
      );


      input.addEventListener(
        'keydown',
        e => {

          if (
            e.key ===
            'Enter'
          ) {
            btn.click();
          }

        }
      );

    });

  }


  // ---------- URGENCY STRIP ----------
  function initUrgency() {

    const strip =
      document.querySelector(
        '[data-urgency]'
      );

    if (!strip) return;


    const countdownEl =
      strip.querySelector(
        '[data-same-day-countdown]'
      );


    function tickCountdown() {

      const now =
        new Date();

      const cutoff =
        new Date();

      cutoff.setHours(
        21,
        0,
        0,
        0
      );


      let remaining;


      if (
        now < cutoff
      ) {

        remaining =
          cutoff - now;

      } else {

        cutoff.setDate(
          cutoff.getDate() + 1
        );

        remaining =
          cutoff - now;

      }


      const h =
        Math.floor(
          remaining /
            3600000
        );

      const m =
        Math.floor(
          (
            remaining %
            3600000
          ) /
            60000
        );

      const s =
        Math.floor(
          (
            remaining %
            60000
          ) /
            1000
        );


      if (countdownEl) {

        countdownEl.textContent =
          `${h}h ${String(m).padStart(
            2,
            '0'
          )}m ${String(s).padStart(
            2,
            '0'
          )}s`;

      }

    }


    tickCountdown();

    setInterval(
      tickCountdown,
      1000
    );


    const stockEl =
      strip.querySelector(
        '[data-stock-left]'
      );

    const stockFill =
      strip.querySelector(
        '[data-stock-fill]'
      );


    if (stockEl) {

      const dayOfYear =
        Math.floor(
          (
            Date.now() -
            new Date(
              new Date().getFullYear(),
              0,
              0
            )
          ) /
            86400000
        );


      const left =
        4 +
        (
          dayOfYear *
          7
        ) %
          9;


      stockEl.textContent =
        left;


      const pct =
        Math.min(
          100,
          (left / 24) *
            100
        );


      if (stockFill) {

        stockFill.style.width =
          pct + '%';

      }

    }


    const giftedEl =
      strip.querySelector(
        '[data-gifted-count]'
      );


    if (giftedEl) {

      const weekOfYear =
        Math.floor(
          Date.now() /
            (
              7 *
              86400000
            )
        );


      const gifted =
        120 +
        (
          weekOfYear *
          13
        ) %
          80;


      giftedEl.textContent =
        gifted;

    }

  }


  // ---------- STICKY MOBILE ATC ----------
  function initStickyAtc() {

    const sticky =
      document.querySelector(
        '[data-sticky-atc]'
      );

    const staticAtc =
      document.querySelector(
        '[data-primary-atc]'
      );


    if (
      !sticky ||
      !staticAtc
    ) {
      return;
    }


    document.body.classList.add(
      'has-sticky-atc'
    );


    const onScroll =
      () => {

        const rect =
          staticAtc
            .getBoundingClientRect();


        if (
          rect.bottom < 0
        ) {

          sticky.classList.add(
            'visible'
          );

        } else {

          sticky.classList.remove(
            'visible'
          );

        }

      };


    window.addEventListener(
      'scroll',
      onScroll,
      {
        passive: true
      }
    );


    onScroll();

  }


  // ---------- PDP ----------
  function initPdp() {

    const pdp =
      document.querySelector(
        '[data-pdp]'
      );

    if (!pdp) return;


    // Variant chips
    const chips =
      pdp.querySelectorAll(
        '[data-variant]'
      );


    chips.forEach(
      c =>
        c.addEventListener(
          'click',
          () => {

            if (
              c.classList.contains(
                'oos'
              )
            ) {
              return;
            }


            chips.forEach(
              x =>
                x.classList.remove(
                  'active'
                )
            );


            c.classList.add(
              'active'
            );


            pdp.dataset
              .selectedVariant =
              c.dataset.variant;

          }
        )
    );


    // Gallery thumb swap
    const thumbs =
      pdp.querySelectorAll(
        '[data-gallery-thumb]'
      );

    const mainImg =
      pdp.querySelector(
        '[data-gallery-main]'
      );

    const mainLabel =
      pdp.querySelector(
        '[data-gallery-main-label]'
      );


    thumbs.forEach(
      (t, i) =>
        t.addEventListener(
          'click',
          () => {

            thumbs.forEach(
              x =>
                x.classList.remove(
                  'active'
                )
            );


            t.classList.add(
              'active'
            );


            if (mainLabel) {

              mainLabel.textContent =
                t.dataset.label ||
                (
                  'Image ' +
                  (i + 1)
                );

            }


            const idx =
              parseInt(
                t.dataset.i ||
                  i,
                10
              );


            if (
              mainImg &&
              window.WTG_IMAGES &&
              Array.isArray(
                window
                  .WTG_IMAGES
                  .pdpGallery
              )
            ) {

              const url =
                window
                  .WTG_IMAGES
                  .pdpGallery[
                    idx
                  ];


              if (url) {
                mainImg.src =
                  url;
              }

            }

          }
        )
    );


    // Offers accordion
    const offers =
      pdp.querySelector(
        '[data-offers]'
      );


    if (offers) {

      const offersHead =
        offers.querySelector(
          '[data-offers-head]'
        );


      if (offersHead) {

        offersHead.addEventListener(
          'click',
          () =>
            offers.classList.toggle(
              'open'
            )
        );

      }

    }


    // Character counters
    pdp
      .querySelectorAll(
        '[data-counter-for]'
      )
      .forEach(input => {

        const max =
          parseInt(
            input.getAttribute(
              'maxlength'
            ),
            10
          );


        const counter =
          pdp.querySelector(
            '[data-counter="' +
              input.dataset
                .counterFor +
              '"]'
          );


        if (!counter) return;


        const upd =
          () => {

            counter.textContent =
              (
                input.value
                  .length || 0
              ) +
              ' / ' +
              max;

          };


        input.addEventListener(
          'input',
          upd
        );


        upd();

      });


    // Gift toggle
    const giftToggle =
      pdp.querySelector(
        '[data-gift-toggle]'
      );

    const giftFields =
      pdp.querySelector(
        '[data-gift-fields]'
      );


    if (
      giftToggle &&
      giftFields
    ) {

      giftToggle.addEventListener(
        'change',
        () => {

          giftFields.style.display =
            giftToggle.checked
              ? 'block'
              : 'none';

        }
      );

    }


    // Existing custom ATC support
    const getProduct =
      () => ({

        id:
          pdp.dataset
            .productId,

        name:
          pdp.dataset
            .productName,

        price:
          parseFloat(
            pdp.dataset
              .productPrice
          ),

        mrp:
          parseFloat(
            pdp.dataset
              .productMrp ||
              0
          ),

        variant:
          pdp.dataset
            .selectedVariant ||
          'default'

      });


    pdp
      .querySelectorAll(
        '[data-atc]'
      )
      .forEach(
        btn =>
          btn.addEventListener(
            'click',
            () => {

              Cart.add(
                getProduct()
              );

              window.toast(
                'Added to bag ✿'
              );

            }
          )
      );


    pdp
      .querySelectorAll(
        '[data-buy-now]'
      )
      .forEach(
        btn =>
          btn.addEventListener(
            'click',
            () => {

              Cart.add(
                getProduct()
              );

              window.location.href =
                'cart.html';

            }
          )
      );

  }


  // ---------- CART PAGE ----------
  function initCart() {

    const cartRoot =
      document.querySelector(
        '[data-cart-root]'
      );


    if (!cartRoot) return;


    render();


    function render() {

      const items =
        Cart.read();


      const list =
        cartRoot.querySelector(
          '[data-cart-list]'
        );


      const empty =
        cartRoot.querySelector(
          '[data-cart-empty]'
        );


      if (
        items.length === 0
      ) {

        if (list) {
          list.style.display =
            'none';
        }

        if (empty) {
          empty.style.display =
            'block';
        }

      } else {

        if (empty) {
          empty.style.display =
            'none';
        }

        if (list) {
          list.style.display =
            '';
        }

      }


      if (list) {

        list.innerHTML =
          items
            .map(i => {

              const img =
                (
                  window.WTG_IMAGES &&
                  window
                    .WTG_IMAGES[
                      i.id
                    ]
                ) ||
                '';


              return `
                <div
                  class="cart-item"
                  data-cart-item="${i.id}|${i.variant}"
                >

                  <div class="ci-thumb">
                    ${
                      img
                        ? `<img src="${img}" alt="" loading="lazy">`
                        : ''
                    }
                  </div>

                  <div class="ci-body">

                    <h4>
                      ${escapeHtml(i.name)}
                    </h4>

                    <div class="variant">
                      ${escapeHtml(i.variant)}
                    </div>

                    <div class="price-row">

                      <span class="price">
                        ₹${i.price.toLocaleString('en-IN')}
                      </span>

                      ${
                        i.mrp &&
                        i.mrp >
                          i.price

                          ? `<span class="mrp">₹${i.mrp.toLocaleString('en-IN')}</span>`

                          : ''
                      }

                    </div>

                  </div>

                  <div class="qty-stepper">

                    <button data-qty-dec>
                      −
                    </button>

                    <span class="qty">
                      ${i.qty}
                    </span>

                    <button data-qty-inc>
                      +
                    </button>

                  </div>

                </div>
              `;

            })
            .join('');


        list
          .querySelectorAll(
            '[data-cart-item]'
          )
          .forEach(row => {

            const [
              id,
              variant
            ] =
              row.dataset
                .cartItem
                .split('|');


            const cur =
              Cart
                .read()
                .find(
                  x =>
                    x.id ===
                      id &&
                    x.variant ===
                      variant
                );


            if (!cur) return;


            const inc =
              row.querySelector(
                '[data-qty-inc]'
              );


            const dec =
              row.querySelector(
                '[data-qty-dec]'
              );


            if (inc) {

              inc.addEventListener(
                'click',
                () => {

                  Cart.setQty(
                    id,
                    variant,
                    cur.qty + 1
                  );

                  render();

                }
              );

            }


            if (dec) {

              dec.addEventListener(
                'click',
                () => {

                  Cart.setQty(
                    id,
                    variant,
                    cur.qty - 1
                  );

                  render();

                }
              );

            }

          });

      }


      const subtotal =
        Cart.subtotal();


      const threshold =
        499;


      const shipping =
        subtotal >= threshold
          ? 0
          : 49;


      const total =
        subtotal + shipping;


      const sub =
        cartRoot.querySelector(
          '[data-sum-subtotal]'
        );


      const ship =
        cartRoot.querySelector(
          '[data-sum-shipping]'
        );


      const tot =
        cartRoot.querySelector(
          '[data-sum-total]'
        );


      if (sub) {

        sub.textContent =
          '₹' +
          subtotal.toLocaleString(
            'en-IN'
          );

      }


      if (ship) {

        ship.textContent =
          shipping === 0
            ? 'FREE'
            : '₹' +
              shipping;

      }


      if (tot) {

        tot.textContent =
          '₹' +
          total.toLocaleString(
            'en-IN'
          );

      }


      // Free shipping progress
      const fsbMsg =
        cartRoot.querySelector(
          '[data-fsb-msg]'
        );


      const fsbFill =
        cartRoot.querySelector(
          '[data-fsb-fill]'
        );


      if (
        fsbMsg &&
        fsbFill
      ) {

        if (
          subtotal >=
          threshold
        ) {

          fsbMsg.innerHTML =
            "✓ <strong>You've unlocked FREE delivery</strong> 🎉";


          fsbFill.style.width =
            '100%';

        } else {

          const togo =
            threshold -
            subtotal;


          fsbMsg.innerHTML =
            `Add <strong>₹${togo.toLocaleString(
              'en-IN'
            )} more</strong> to unlock free delivery.`;

          fsbFill.style.width =
            Math.min(
              100,
              (
                subtotal /
                threshold
              ) *
                100
            ) +
            '%';

        }

      }

    }

  }


  // ---------- HEADER PINCODE ----------
  function initHeaderPincode() {

    const pill =
      document.querySelector(
        '[data-header-pincode]'
      );


    if (!pill) return;


    const saved =
      localStorage.getItem(
        'wtg_pincode'
      );


    if (saved) {
      pill.textContent =
        saved;
    }

  }


  // ---------- WHATSAPP CAPTURE ----------
  function initWaCapture() {

    const form =
      document.querySelector(
        '[data-wa-form]'
      );


    if (!form) return;


    form.addEventListener(
      'submit',
      e => {

        e.preventDefault();

        window.toast(
  "We'll remind you 🎂"
);

        form.reset();

      }
    );

  }


  // ---------- HELPERS ----------
  function escapeHtml(str) {

    return String(str).replace(
      /[&<>"']/g,
      s =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        })[s]
    );

  }


  // ---------- BOOT ----------
  function ready(fn) {

    if (
      document.readyState !==
      'loading'
    ) {

      fn();

    } else {

      document.addEventListener(
        'DOMContentLoaded',
        fn
      );

    }

  }


  ready(function() {

    Cart.syncBadges();

    initAnnounce();

    initHeaderPincode();

    initPincode();

    initPdp();

    initUrgency();

    initStickyAtc();

    initCart();

    initWaCapture();

  });

})();